import { render, staticRenderFns } from "./BoardWriteNoticeLayout.vue?vue&type=template&id=0a2f9395&scoped=true&"
import script from "./BoardWriteNoticeLayout.vue?vue&type=script&lang=js&"
export * from "./BoardWriteNoticeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2f9395",
  null
  
)

export default component.exports